"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageStructureAncestors = pageStructureAncestors;
const page_structure_tree_1 = require("./page-structure-tree");
/** Walks p, including the starting entry and the first missing entry; never follows cycles or tombstones. */
function* pageStructureAncestors(entries, start) {
    const seen = new Set();
    let id = start;
    while (id !== null && !seen.has(id)) {
        seen.add(id);
        const entry = entries.get(id);
        yield [id, entry];
        if (!entry ||
            entry.p === page_structure_tree_1.PAGE_TREE_DELETED_ID ||
            entry.p === page_structure_tree_1.PAGE_TREE_UNPLACED_ID)
            return;
        id = entry.p;
    }
}
